import { userSessionTypes, platformNames } from '.';
import {
  NEED_HELP,
  NYKAA_CSR,
  MY_ORDERS,
  MY_WALLET,
  MY_PROFILE,
  MY_WISHLIST,
  HELP_CENTER,
  GIFT_CARDS,
  AUTHENTICITY,
  NYKAA_PRIVE,
  NYKAA_SUBSCRIPTION,
  RESPONSIBLE_DISCLOSURE,
  VIDEO_CONSULTATION,
  SUSTAINABILITY,
} from './strings';
import { HELP_CENTER_URLS_POWERED_BY_KAPTURE, MY_ORDERS_URLS } from './urls';
import { MenuItemsMap, MenuItem } from 'types/Header';
import { KEBAB_MENU_KEYS } from 'shared/store/remoteConfig/keys';

const { beauty: BEAUTY_HELP_CENTER, men: MEN_HELP_CENTER } =
  HELP_CENTER_URLS_POWERED_BY_KAPTURE;
const { beauty: BEAUTY_MY_ORDERS, men: MEN_MY_ORDERS } = MY_ORDERS_URLS;

// Destructure all kebab menu keys for cleaner usage
const {
  NEED_HELP_ENABLED,
  AUTHENTICITY_ENABLED,
  CSR_ENABLED,
  RESPONSIBLE_DISCLOSURE_ENABLED,
  MY_ORDERS_ENABLED,
  PRIVE_ENABLED,
  WALLET_ENABLED,
  SUBSCRIPTION_ENABLED,
  MY_PROFILE_ENABLED,
  MY_WISHLIST_ENABLED,
  REVIEWS_ENABLED,
  VIDEO_CONSULTATION_ENABLED,
  HELP_CENTER_ENABLED,
} = KEBAB_MENU_KEYS;
export const menuItems: MenuItemsMap = {
  [platformNames.NYKAA]: {
    [userSessionTypes.GUEST]: [
      {
        link: BEAUTY_HELP_CENTER,
        displayText: NEED_HELP,
        configKey: NEED_HELP_ENABLED,
      },
      {
        link: '/authenticity-nykaa-guarantee?intcmp=hp,header,1,authenticity',
        displayText: AUTHENTICITY,
        configKey: AUTHENTICITY_ENABLED,
      },
      {
        link: '/nykaa-csr',
        displayText: NYKAA_CSR,
        configKey: CSR_ENABLED,
      },
      {
        link: '/responsible-disclosure',
        displayText: RESPONSIBLE_DISCLOSURE,
        configKey: RESPONSIBLE_DISCLOSURE_ENABLED,
      },
    ],
    [userSessionTypes.LOGGED_IN]: [
      {
        link: BEAUTY_MY_ORDERS,
        displayText: MY_ORDERS,
        configKey: MY_ORDERS_ENABLED,
      },
      {
        link: '/prive',
        displayText: NYKAA_PRIVE,
        configKey: PRIVE_ENABLED,
      },
      {
        link: '/nykaaWallet/add/?ptype=nykaaWallet',
        displayText: MY_WALLET,
        configKey: WALLET_ENABLED,
      },
      {
        link: '/subscription',
        displayText: NYKAA_SUBSCRIPTION,
        configKey: SUBSCRIPTION_ENABLED,
      },
      {
        link: '/myProfile',
        displayText: MY_PROFILE,
        configKey: MY_PROFILE_ENABLED,
      },
      {
        link: '/wishlist/',
        displayText: MY_WISHLIST,
        configKey: MY_WISHLIST_ENABLED,
      },
      {
        link: '/sales/order/history/v2?ptype=myOrder',
        displayText: 'My Product Reviews',
        configKey: REVIEWS_ENABLED,
      },
      {
        link: '/authenticity-nykaa-guarantee?intcmp=hp,header,1,authenticity',
        displayText: AUTHENTICITY,
        configKey: AUTHENTICITY_ENABLED,
      },
      {
        link: '/video-consultation',
        displayText: VIDEO_CONSULTATION,
        tag: 'NEW',
        configKey: VIDEO_CONSULTATION_ENABLED,
      },
      {
        link: BEAUTY_HELP_CENTER,
        displayText: HELP_CENTER,
        configKey: HELP_CENTER_ENABLED,
      },
      {
        link: '/nykaa-csr',
        displayText: NYKAA_CSR,
        configKey: CSR_ENABLED,
      },
      {
        link: '/responsible-disclosure',
        displayText: RESPONSIBLE_DISCLOSURE,
        configKey: RESPONSIBLE_DISCLOSURE_ENABLED,
      },
    ],
  },
  [platformNames.NYSAA]: {
    [userSessionTypes.GUEST]: [
      {
        link: BEAUTY_HELP_CENTER,
        displayText: NEED_HELP,
      },
      {
        link: '/authenticity-nykaa-guarantee/lp?intcmp=hp,header,1,authenticity',
        displayText: AUTHENTICITY,
      },
      {
        link: '/nykaa-csr/lp',
        displayText: NYKAA_CSR,
      },
      {
        link: '/sustainability/lp',
        displayText: SUSTAINABILITY,
      },
      {
        link: '/responsible-disclosure/lp',
        displayText: RESPONSIBLE_DISCLOSURE,
      },
    ],
    [userSessionTypes.LOGGED_IN]: [
      {
        link: BEAUTY_MY_ORDERS,
        displayText: MY_ORDERS,
      },
      {
        link: '/prive',
        displayText: NYKAA_PRIVE,
      },
      {
        link: '/nykaaWallet/add/?ptype=nykaaWallet',
        displayText: MY_WALLET,
      },
      // {
      //   link: '/subscription',
      //   displayText: NYKAA_SUBSCRIPTION,
      // },
      {
        link: '/myProfile',
        displayText: MY_PROFILE,
      },
      {
        link: '/wishlist/',
        displayText: MY_WISHLIST,
      },
      // {
      //   link: '/sales/order/history/v2?ptype=myOrder',
      //   displayText: 'My Product Reviews',
      // },
      {
        link: '/authenticity-nykaa-guarantee/lp?intcmp=hp,header,1,authenticity',
        displayText: AUTHENTICITY,
      },
      {
        link: '/video-consultation',
        displayText: VIDEO_CONSULTATION,
        tag: 'NEW',
      },
      {
        link: BEAUTY_HELP_CENTER,
        displayText: HELP_CENTER,
      },
      {
        link: '/nykaa-csr/lp',
        displayText: NYKAA_CSR,
      },
      {
        link: '/sustainability/lp',
        displayText: SUSTAINABILITY,
      },
      {
        link: '/responsible-disclosure/lp',
        displayText: RESPONSIBLE_DISCLOSURE,
      },
    ],
  },
  [platformNames.MEN]: {
    [userSessionTypes.GUEST]: [
      {
        link: MEN_HELP_CENTER,
        displayText: NEED_HELP,
      },
      {
        link: '/giftcard/list',
        displayText: GIFT_CARDS,
      },
      {
        link: '/responsible-disclosure/lp',
        displayText: RESPONSIBLE_DISCLOSURE,
      },
    ],
    [userSessionTypes.LOGGED_IN]: [
      {
        link: MEN_MY_ORDERS,
        displayText: MY_ORDERS,
      },
      {
        link: '/myProfile',
        displayText: MY_PROFILE,
      },
      {
        link: '/nykaaWallet/add/?ptype=nykaaWallet',
        displayText: MY_WALLET,
      },
      {
        link: '/wishlist/',
        displayText: MY_WISHLIST,
      },
      // {
      //   link: '/sales/order/history/v2?ptype=myOrder',
      //   displayText: 'My Product Reviews',
      // },
      {
        link: MEN_HELP_CENTER,
        displayText: HELP_CENTER,
      },
      {
        link: '/responsible-disclosure/lp',
        displayText: RESPONSIBLE_DISCLOSURE,
      },
    ],
  },
};

// Function to filter menu items based on remote config
export const getFilteredMenuItems = (
  platform: string,
  userType: string,
  kebabMenuConfig?: {
    guest?: Record<string, boolean>;
    loggedIn?: Record<string, boolean>;
  }
) => {
  const items = menuItems[platform]?.[userType] || [];

  // If no config provided, return all items
  if (!kebabMenuConfig) return items;

  const configToUse =
    userType === userSessionTypes.GUEST
      ? kebabMenuConfig.guest
      : kebabMenuConfig.loggedIn;

  // If no config for this user type, return all items
  if (!configToUse) return items;

  return items.filter((item: MenuItem) => {
    // If no configKey, always show the item
    if (!item.configKey) return true;
    // Check if the config key is enabled
    return configToUse[item.configKey] === true;
  });
};

export const TOP_INAPP_CLICKED = 'top_inapp_clicked';
